import { hasLocalStorage } from '../../common/helpers/window';

export const LTP_SESSION_ID_STORAGE_KEY = 'wb-us-ltp-session-id-v1';

/** `Crypto.randomUUID` exists at runtime in modern browsers but may be missing from older TS `lib` typings. */
interface CryptoWithRandomUUID {
  randomUUID?: () => string;
}

const generateId = (): string => {
  const c = typeof crypto !== 'undefined' ? crypto : undefined;
  const withUuid = (c as unknown) as CryptoWithRandomUUID | undefined;
  if (withUuid && typeof withUuid.randomUUID === 'function') {
    return withUuid.randomUUID();
  }
  return `${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 12)}`;
};

/**
 * Persists in localStorage so all LTP dataLayer events share one id until storage is cleared.
 */
export const getOrCreateLtpSessionId = (): string | undefined => {
  if (!hasLocalStorage()) {
    return undefined;
  }
  try {
    const existing = localStorage.getItem(LTP_SESSION_ID_STORAGE_KEY);
    if (existing && existing.length > 0) {
      return existing;
    }
    const id = generateId();
    localStorage.setItem(LTP_SESSION_ID_STORAGE_KEY, id);
    return id;
  } catch {
    return undefined;
  }
};
